import { Tooltip, TooltipProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { useMediaQueries } from 'layout/MediaQueriesProvider';

interface IDevSandboxTooltipProps extends TooltipProps {
  label?: ReactNode | null;
  children: ReactNode;
}

const DevSandboxTooltip = ({ label, children, ...props }: IDevSandboxTooltipProps) => {
  const { isMobile } = useMediaQueries();

  if (!label || isMobile) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      label={label}
      placement="top"
      hasArrow
      arrowSize={6}
      bg="gray.600"
      color="white"
      fontSize="11px"
      fontWeight="500"
      letterSpacing="0.01em"
      lineHeight="1.4"
      px={2.5}
      py={1.5}
      borderRadius="4px"
      border="1px solid"
      borderColor="whiteAlpha.200"
      boxShadow="0 1px 4px rgba(0,0,0,0.4), 0 4px 12px rgba(0,0,0,0.25)"
      openDelay={120}
      closeDelay={0}
      zIndex="tooltip"
      maxW="240px"
      arrowShadowColor="rgba(255,255,255,0.08)"
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default DevSandboxTooltip;
